// Scripts the page works without, loaded after it is up: PostHog, say. When a
// chunk the page needs fails to load, the page reloads once
// (src/lib/preload-error-reload.ts); for one of these that would stop a
// playing video and lose the reader's place to retry something they never
// see. So their imports go through optionalImport, the reload handler leaves
// their failures alone, and the import rejects for its caller to go without.
//
// Vite reports a failed import as `vite:preloadError` from inside the
// import's own promise chain, before the caller sees the rejection, and the
// event does not say which import failed: Chrome and Firefox put the chunk's
// address in the error's message, Safari does not ("Importing a module script
// failed."). So a failure while an optional import is loading is taken to be
// that import's. A chunk the page needs that fails in the same moment is then
// not reloaded for: its error reaches Sentry, as before the reload handler.

let loading = 0;

/** Loads a script the page works without; a failure rejects, and never reloads the page. */
export function optionalImport<T>(load: () => Promise<T>): Promise<T> {
  loading += 1;
  let promise: Promise<T>;
  try {
    promise = load();
  } catch (error) {
    loading -= 1;
    return Promise.reject(error);
  }
  return promise.finally(() => {
    loading -= 1;
  });
}

/** Whether an optional import is loading, so a failed load now is most likely its own. */
export function optionalImportLoading(): boolean {
  return loading > 0;
}
